var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDbIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 14.9072V23.2405C21.25 26.002 16.8848 28.2405 11.5 28.2405C6.11522 28.2405 1.75 26.002 1.75 23.2405V14.9072M21.25 14.9072V6.57385M21.25 14.9072C21.25 17.6687 16.8848 19.9072 11.5 19.9072C6.11522 19.9072 1.75 17.6687 1.75 14.9072M1.75 14.9072V6.57385M21.25 6.57385C21.25 3.81244 16.8848 1.57385 11.5 1.57385C6.11522 1.57385 1.75 3.81244 1.75 6.57385M21.25 6.57385C21.25 9.33527 16.8848 11.5739 11.5 11.5739C6.11522 11.5739 1.75 9.33527 1.75 6.57385",
    stroke: "#233F39",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbIcon);
export default __webpack_public_path__ + "static/media/dbIcon.697c09c789cd54e5cb524747c2a93c4e.svg";
export { ForwardRef as ReactComponent };